import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferdev.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
    
    recuperar(p_email, p_usuario, p_retdeuda, p_transoli, p_prcmanual, p_ejecutivo, p_fecpago) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferdev.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_retdeuda": p_retdeuda,
					"p_transoli": p_transoli,
					"p_prcmanual": p_prcmanual,
					"p_ejecutivo": p_ejecutivo,
					"p_fecpago": p_fecpago
				  })
			})
	},

	finiquitos(p_email, p_usuario, p_poliza) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferdev.recuperar_finiquito",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza
				  })
			})
	},

	transferir(p_email, p_usuario, p_registro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferdev.transferir",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_registro": p_registro
				  })
			})
	},

	guardar_observacion(p_email, p_usuario, p_poliza, p_beneficiario, p_fecpago, p_observacion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferdev.guardar_observacion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_beneficiario": p_beneficiario,
					"p_fecpago": p_fecpago,
					"p_observacion": p_observacion
				  })
			})
	},
	
	recuperar_beneficiario(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferdev.recuperar_beneficiario",
				"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_siniestro": p_siniestro
				})
			})
	},

	fechatransferencia(p_email, p_usuario, p_fecha, p_registro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_transferdev.fechatransferencia",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fecha": p_fecha,
					"p_registro": p_registro
				  })
			})
	},

}